import { CONFIG } from '../constants';

/**
 * Time Service
 * Handles all time-related operations
 */

/**
 * Format time to readable string
 * @param {Date} date - The date to format
 * @returns {string} - Formatted time
 */
export const formatTime = (date) => {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Format date to readable string
 * @param {Date} date - The date to format
 * @returns {string} - Formatted date
 */
export const formatDate = (date) => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Format day to readable string
 * @param {Date} date - The date to format
 * @returns {string} - Formatted day
 */
export const formatDay = (date) => {
  return date.toLocaleDateString('en-US', { weekday: 'long' });
};

/**
 * Check if it's daytime based on current hour
 * @param {Date} date - The date to check
 * @returns {boolean} - True if daytime
 */
export const isDaytime = (date = new Date()) => {
  const hour = date.getHours();
  return hour >= CONFIG.DAY_START_HOUR && hour < CONFIG.DAY_END_HOUR;
};

/**
 * Get time of day (morning, afternoon, evening, night)
 * @param {Date} date - The date to check
 * @returns {string} - Time of day
 */
export const getTimeOfDay = (date = new Date()) => {
  const hour = date.getHours();
  
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
};
